/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import moment from 'moment';
import { TimeInterval } from './types';

export const getApplicableLabel = (
  isFirstElement: boolean,
  value: number,
  interval: TimeInterval,
  lng: string = 'en-US'
): string => {
  if (interval === TimeInterval.Monthly && isFirstElement) {
    return moment(value)
      .locale(lng)
      .format('MMM DD');
  } else {
    if (interval === TimeInterval.Monthly) {
      return moment(value)
        .locale(lng)
        .format('DD');
    }
  }
  if (interval === TimeInterval.Yearly && isFirstElement) {
    return moment(value)
      .locale(lng)
      .format('MMM YYYY');
  }
  return moment(value)
    .locale(lng)
    .format('MMM');
};
